<template lang="pug">
  .drawer-contents
    .drawer-top
      slot(name="top")
    .drawer-main
      .drawer-main-contents
        slot
    .drawer-footer
      slot(name="bottom")
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
.drawer-contents {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  // Fixes ios safarai issue (width / height 100% alone didnt work)
  position: absolute;
  top: 0;
  left: 0;
}

.drawer-main {
  flex-grow: 1;
  position: relative;

  .drawer-main-contents {
    position: absolute;
    padding: $space-s;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.drawer-footer, .drawer-top {
  padding: $space-s;

  &:empty {
    display: none;
  }
}

.drawer-footer {
  background-color: $color-white;
  z-index: 1;
  -webkit-box-shadow: 0px -2px 8px 0px $color-gray-light;
  -moz-box-shadow: 0px -2px 8px 0px $color-gray-light;
  box-shadow: 0px -2px 8px 0px $color-gray-light;
}
</style>
